(function () {
  var PRODUCT_PATH = "/products/hover-shelving";
  var CUSTOMIZER_URL = "https://coilanddrift-builder-d6026f9973f7.herokuapp.com/";
  var DIALOG_ID = "HoverCustomizerDialog";
  var OPEN_CLASS = "HoverCustomizerDialog-isOpen";
  var ACTIVE_CLASS = "HoverCustomizerDialog--active";
  var CLOSING_CLASS = "HoverCustomizerDialog--closing";
  var LOADED_CLASS = "HoverCustomizerDialog--loaded";
  var ANIMATION_DURATION = 220;

  var normalizedPath = window.location.pathname.replace(/\/$/, "");
  var searchParams = new URLSearchParams(window.location.search);
  var isPreviewEnabled = searchParams.get("preview_customizer") === "true";
  console.log('isPreviewEnabled:',isPreviewEnabled)
  if (
    !isPreviewEnabled ||
    normalizedPath !== PRODUCT_PATH &&
    normalizedPath.slice(-PRODUCT_PATH.length) !== PRODUCT_PATH
  ) {
    return;
  }

  function injectStyles() {
    if (document.getElementById("HoverCustomizerStyles")) {
      return;
    }

    var styles = document.createElement("style");
    styles.id = "HoverCustomizerStyles";
    styles.textContent = [
      "html." + OPEN_CLASS + ",",
      "html." + OPEN_CLASS + " body {",
      "  overflow: hidden;",
      "}",
      "",
      ".HoverCustomizerDialog {",
      "  position: fixed;",
      "  inset: 0;",
      "  width: 100vw;",
      "  max-width: none;",
      "  height: 100vh;",
      "  height: 100dvh;",
      "  max-height: none;",
      "  margin: 0;",
      "  padding: 0;",
      "  border: 0;",
      "  background: #fff;",
      "  opacity: 0;",
      "  transform: scale(0.985);",
      "  transition: opacity " + ANIMATION_DURATION + "ms ease, transform " + ANIMATION_DURATION + "ms ease;",
      "}",
      "",
      ".HoverCustomizerDialog::backdrop {",
      "  background: rgba(0, 0, 0, 0.6);",
      "  opacity: 0;",
      "  transition: opacity " + ANIMATION_DURATION + "ms ease;",
      "}",
      "",
      ".HoverCustomizerDialog." + ACTIVE_CLASS + " {",
      "  opacity: 1;",
      "  transform: scale(1);",
      "}",
      "",
      ".HoverCustomizerDialog." + ACTIVE_CLASS + "::backdrop {",
      "  opacity: 1;",
      "}",
      "",
      ".HoverCustomizerDialog." + CLOSING_CLASS + " {",
      "  opacity: 0;",
      "  transform: scale(0.985);",
      "}",
      "",
      ".HoverCustomizerDialog." + CLOSING_CLASS + "::backdrop {",
      "  opacity: 0;",
      "}",
      "",
      ".HoverCustomizerDialog__Header {",
      "  position: absolute;",
      "  z-index: 2;",
      "  top: 16px;",
      "  right: 16px;",
      "  left: 16px;",
      "  display: flex;",
      "  align-items: center;",
      "  justify-content: space-between;",
      "  pointer-events: none;",
      "}",
      "",
      ".HoverCustomizerDialog__Title {",
      "  visibility: hidden;",
      "}",
      "",
      ".HoverCustomizerDialog__Close {",
      "  display: inline-flex;",
      "  align-items: center;",
      "  justify-content: center;",
      "  width: 44px;",
      "  height: 44px;",
      "  margin-left: auto;",
      "  border: 0;",
      "  border-radius: 50%;",
      "  background: #fff;",
      "  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.18);",
      "  color: inherit;",
      "  cursor: pointer;",
      "  pointer-events: auto;",
      "}",
      "",
      ".HoverCustomizerDialog__Loader {",
      "  position: absolute;",
      "  z-index: 1;",
      "  inset: 0;",
      "  display: flex;",
      "  flex-direction: column;",
      "  align-items: center;",
      "  justify-content: center;",
      "  gap: 14px;",
      "  background: #fff;",
      "  color: inherit;",
      "  opacity: 1;",
      "  transition: opacity " + ANIMATION_DURATION + "ms ease, visibility " + ANIMATION_DURATION + "ms ease;",
      "}",
      "",
      ".HoverCustomizerDialog." + LOADED_CLASS + " .HoverCustomizerDialog__Loader {",
      "  visibility: hidden;",
      "  opacity: 0;",
      "}",
      "",
      ".HoverCustomizerDialog__Spinner {",
      "  width: 42px;",
      "  height: 42px;",
      "  border: 2px solid rgba(0, 0, 0, 0.14);",
      "  border-top-color: currentColor;",
      "  border-radius: 50%;",
      "  animation: HoverCustomizerDialog-spin 800ms linear infinite;",
      "}",
      "",
      ".HoverCustomizerDialog__LoaderText {",
      "  font-size: 13px;",
      "  letter-spacing: 0.08em;",
      "  text-transform: uppercase;",
      "}",
      "",
      "@keyframes HoverCustomizerDialog-spin {",
      "  to {",
      "    transform: rotate(360deg);",
      "  }",
      "}",
      "",
      ".HoverCustomizerDialog__Close svg {",
      "  width: 16px;",
      "  height: 16px;",
      "}",
      "",
      ".HoverCustomizerDialog__Frame {",
      "  display: block;",
      "  width: 100%;",
      "  height: 100%;",
      "  border: 0;",
      "}",
      "",
      "@media (prefers-reduced-motion: reduce) {",
      "  .HoverCustomizerDialog__Spinner {",
      "    animation: none;",
      "  }",
      "",
      "  .HoverCustomizerDialog,",
      "  .HoverCustomizerDialog::backdrop,",
      "  .HoverCustomizerDialog__Loader {",
      "    transition: none;",
      "  }",
      "}"
    ].join("\n");

    document.head.appendChild(styles);
  }

  function getCloseIcon() {
    return [
      '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false">',
      '  <path d="M1 1l14 14M15 1L1 15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"></path>',
      "</svg>"
    ].join("");
  }

  function getDialog() {
    var existingDialog = document.getElementById(DIALOG_ID);

    if (existingDialog) {
      return existingDialog;
    }

    var dialog = document.createElement("dialog");
    dialog.id = DIALOG_ID;
    dialog.className = "HoverCustomizerDialog";
    dialog.setAttribute("aria-label", "Hover Shelving Customizer");
    dialog.innerHTML = [
      '<div class="HoverCustomizerDialog__Header">',
      '  <span class="HoverCustomizerDialog__Title">Customize Hover Shelving</span>',
      '  <button type="button" class="HoverCustomizerDialog__Close" aria-label="Close">',
      getCloseIcon(),
      "  </button>",
      "</div>",
      '<div class="HoverCustomizerDialog__Loader" role="status" aria-live="polite">',
      '  <span class="HoverCustomizerDialog__Spinner" aria-hidden="true"></span>',
      '  <span class="HoverCustomizerDialog__LoaderText">Loading customizer</span>',
      "</div>",
      '<iframe class="HoverCustomizerDialog__Frame" src="' +
        CUSTOMIZER_URL +
        '" title="Hover Shelving Customizer" loading="eager" allowfullscreen></iframe>'
    ].join("");

    dialog.querySelector(".HoverCustomizerDialog__Frame").addEventListener("load", function () {
      dialog.classList.add(LOADED_CLASS);
    });
    dialog.querySelector(".HoverCustomizerDialog__Close").addEventListener("click", closeDialog);
    dialog.addEventListener("click", function (event) {
      if (event.target === dialog) {
        closeDialog();
      }
    });
    dialog.addEventListener("cancel", function (event) {
      event.preventDefault();
      closeDialog();
    });
    dialog.addEventListener("close", function () {
      dialog.classList.remove(ACTIVE_CLASS, CLOSING_CLASS);
      unlockScroll();
    });
    document.body.appendChild(dialog);

    return dialog;
  }

  function lockScroll() {
    document.documentElement.classList.add(OPEN_CLASS);
  }

  function unlockScroll() {
    document.documentElement.classList.remove(OPEN_CLASS);
  }

  function openDialog() {
    injectStyles();

    var dialog = getDialog();

    if (dialog.open) {
      return;
    }

    dialog.classList.remove(CLOSING_CLASS);

    if (typeof dialog.showModal === "function") {
      dialog.showModal();
    } else {
      dialog.setAttribute("open", "");
    }

    lockScroll();
    window.requestAnimationFrame(function () {
      dialog.classList.add(ACTIVE_CLASS);
    });
  }

  function closeDialog() {
    var dialog = document.getElementById(DIALOG_ID);

    if (!dialog) {
      unlockScroll();
      return;
    }

    if (!dialog.open || dialog.classList.contains(CLOSING_CLASS)) {
      return;
    }

    dialog.classList.remove(ACTIVE_CLASS);
    dialog.classList.add(CLOSING_CLASS);

    window.setTimeout(function () {
      if (typeof dialog.close === "function" && dialog.open) {
        dialog.close();
      } else {
        dialog.removeAttribute("open");
        dialog.classList.remove(CLOSING_CLASS);
        unlockScroll();
      }
    }, ANIMATION_DURATION);
  }

  function openDialogFromClick(event) {
    if (!event.target || typeof event.target.closest !== "function") {
      return;
    }

    var customizeToggle = event.target.closest(".ProductForm__BuyButtons .customize-toggle");

    if (!customizeToggle) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    openDialog();
  }

  document.addEventListener(
    "click",
    openDialogFromClick,
    true
  );
})();
